import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center text-white">
      <h1 className="font-display text-5xl font-semibold" style={{ fontFamily: 'Space Grotesk' }}>404</h1>
      <p className="text-white/70">This page is closed for the night.</p>
      <Link to="/"><Button className="rounded-xl bg-[#F6B24A] text-[#1A1208] hover:bg-[#FFC065]">Back to feed</Button></Link>
    </div>
  );
}
